import { css } from '@emotion/react';
import React from 'react';

import { useFeatureSwitchStatus } from '@/features/hooks';
import { HalfScreenLayout } from '@/ui/layout';
import { Spacer } from '@/ui/spacing';
import { Heading } from '@/ui/typography';

import BookingCheckoutSidebarContainer from '../BookingCheckoutSidebar.container';

const SummaryElements = (props: { bookingId: string; hotelSlug: string }) => {
  return (
    <div
      css={css`
        position: sticky;
        top: 61px;
      `}
    >
      <div>
        <Spacer s="xl" />
        <BookingCheckoutSidebarContainer
          bookingId={props.bookingId}
          hotelSlug={props.hotelSlug}
        />
        <Spacer s="xl" />
      </div>
    </div>
  );
};

const FormElements = (props: {
  children: React.ReactNode | string;
  title: React.ReactNode | string;
}) => (
  <>
    <Spacer s="xl" />
    <Heading style="heading1" as="h1">
      {props.title}
    </Heading>
    <Spacer s="xl" />
    {props.children}
    <Spacer s="xl" />
  </>
);

interface CheckoutHalfScreenContainerProps {
  title: React.ReactNode;
  children: React.ReactNode;
  bookingId: string;
  hotelSlug: string;
}

export const CheckoutHalfScreenContainer = (
  props: CheckoutHalfScreenContainerProps
) => {
  const isFlipFormsEnabled = useFeatureSwitchStatus('flip-forms');

  const summaryElements = (
    <SummaryElements bookingId={props.bookingId} hotelSlug={props.hotelSlug} />
  );
  const formElements = (
    <FormElements title={props.title}>{props.children}</FormElements>
  );

  const left = isFlipFormsEnabled ? summaryElements : formElements;
  const right = isFlipFormsEnabled ? formElements : summaryElements;

  return <HalfScreenLayout left={left} right={right} />;
};
